import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Loader, Panel, Placeholder, Table } from "rsuite";
import AdminDashboard from "../../components/AdminDashboard";
import { DriverStatus } from "../../my-enum";
import { Driver, Vehicle } from "../../my-type";
import { authUserData } from "../../service";
import { getDriversByTeamCode } from "../../service/DriverService";

export default function DriverApprovalList() {
  const [drivers, setDrivers] = useState<Driver[]>([]);
  const [vehicleTypes, setVehicleTypes] = useState<Vehicle[]>([]);
  const [loading, setLoading] = useState(true);
  const [authUser, setAuthUser] = useState<any>(null);
  const navigate = useNavigate();
  const user = authUserData();

  useEffect(() => {
    const loadAuthUser = async () => {
      const userData = await authUserData();
      setAuthUser(userData);
      setLoading(false);
    };
    void loadAuthUser();
  }, []);

  useEffect(() => {
    if (loading) return;
    if (!authUser) {
      navigate("/login");
      return;
    }

    async function fetchDrivers() {
      const teamCode = authUser.team.code;
      const fetchedDrivers = await getDriversByTeamCode(teamCode);
      setDrivers(fetchedDrivers || []);
    }

    void fetchDrivers();
  }, [authUser, loading, navigate]);

  useEffect(() => {
    if (vehicleTypes.length === 0 && user?.team?.vehicleData) {
      const vehicleList = JSON.parse(user.team.vehicleData);
      setVehicleTypes(vehicleList);
    }
  }, [user, vehicleTypes.length]);

  const getVehicleName = (vehicleID?: string) =>
    vehicleTypes.length > 0
      ? vehicleTypes.find((vehicle) => vehicle.vehicleID === vehicleID)?.vehiclename || "N/A"
      : "N/A";

  const pendingDrivers = drivers.filter((driver) => driver.status === DriverStatus.未驗證);

  return (
    <AdminDashboard title="待核可司機">
      <Panel header={`待核可司機 (${pendingDrivers.length} 筆)`} bordered className="fleet-review-panel">
        {loading ? (
          <div style={{ textAlign: "center", padding: "40px" }}>
            <Loader size="lg" content="載入中..." />
          </div>
        ) : pendingDrivers.length > 0 ? (
          <Table
            data={pendingDrivers}
            autoHeight
            hover
            bordered
            cellBordered
            rowHeight={60}
            onRowClick={(rowData) => navigate(`/drivers/${(rowData as Driver).userUID}/edit`)}
          >
            <Table.Column width={150} fixed>
              <Table.HeaderCell>姓名</Table.HeaderCell>
              <Table.Cell dataKey="driverName" />
            </Table.Column>
            <Table.Column width={150}>
              <Table.HeaderCell>車號</Table.HeaderCell>
              <Table.Cell dataKey="licencePlateNumber" />
            </Table.Column>
            <Table.Column width={150}>
              <Table.HeaderCell>電話</Table.HeaderCell>
              <Table.Cell dataKey="phoneNumber" />
            </Table.Column>
            <Table.Column width={150}>
              <Table.HeaderCell>廠牌</Table.HeaderCell>
              <Table.Cell dataKey="carBrand" />
            </Table.Column>
            <Table.Column width={150}>
              <Table.HeaderCell>車型</Table.HeaderCell>
              <Table.Cell dataKey="carModel" />
            </Table.Column>
            <Table.Column width={200}>
              <Table.HeaderCell>車種</Table.HeaderCell>
              <Table.Cell>
                {(rowData: Driver) => getVehicleName(rowData.vehicleID)}
              </Table.Cell>
            </Table.Column>
            <Table.Column width={150}>
              <Table.HeaderCell>車色</Table.HeaderCell>
              <Table.Cell dataKey="carColor" />
            </Table.Column>
            <Table.Column width={140} fixed="right">
              <Table.HeaderCell>操作</Table.HeaderCell>
              <Table.Cell>
                {(rowData: Driver) => (
                  <Button
                    appearance="link"
                    onClick={() => navigate(`/drivers/${rowData.userUID}/edit`)}
                  >
                    前往審核
                  </Button>
                )}
              </Table.Cell>
            </Table.Column>
          </Table>
        ) : (
          <div style={{ textAlign: "center", padding: "40px" }}>
            <Placeholder.Paragraph rows={3} />
            <p style={{ color: "#999" }}>目前沒有待核可的司機</p>
          </div>
        )}
      </Panel>
    </AdminDashboard>
  );
}
